import { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

async function fetchMeanTimeToResolveSummary(queryString) {
  const url = `${QUALITY_SERVICE_API_URL}/hub/mean-time-to-resolve/summary${queryString ? `?${queryString}` : ''}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (err) {
    console.error('[useMeanTimeToResolveSummary] fetch failed:', {
      status: err.response?.status,
      message: err.message,
    });
    throw err;
  }
}

function useMeanTimeToResolveSummary(filters, dateRange) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Build query string
  const params = new URLSearchParams();
  ['domain', 'group', 'unit'].forEach(key => {
    (filters?.[key] || []).forEach(value => params.append(key, value));
  });

  const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  if (dateRange?.startDate) params.set('from', formatDate(dateRange.startDate));
  if (dateRange?.endDate) params.set('to', formatDate(dateRange.endDate));

  const queryString = params.toString();

  const fetchSummary = useCallback(async (isCancelled = () => false) => {
    if (!dateRange?.startDate || !dateRange?.endDate) {
      setData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setData(null);
    try {
      const summary = await fetchMeanTimeToResolveSummary(queryString);
      if (!isCancelled()) setData(summary);
    } catch (err) {
      if (!isCancelled()) setError(err);
    } finally {
      if (!isCancelled()) setLoading(false);
    }
  }, [queryString, dateRange?.startDate, dateRange?.endDate]);

  useEffect(() => {
    let cancelled = false;
    fetchSummary(() => cancelled);
    return () => { cancelled = true; };
  }, [fetchSummary]);

  return { data, loading, error, refetch: () => fetchSummary() };
}

export default useMeanTimeToResolveSummary;
